<template>
  <div class="about">

    <div class="banner">
      <div class="banner-desc">
        <p class="banner-desc1">关于我们</p>
        <!-- <p class="banner-desc2">霖珑云科旗下发薪平台</p> -->
      </div>
      <div class="banner-bottom">
        <img class="banner-img" src="../../assets/banner-img.png" alt="不木钱包">
      </div>
    </div>

    <div class="introduction">
      <div class="concent">
        <div class="title">
          <div class="title-text">不木钱包简介</div>
        </div>
        <div class="desc">
          <p class="desc-text">不木钱包是霖珑云科旗下针对多重用工企业开发的智能发薪工具。</p>
          <p class="desc-text"> 运用大数据、人工智能、互联网等技术，解决传统发薪中流程繁琐、差错率高、成本高的问题，同时满足企业复杂的薪酬绩效体系和员工即时查询薪资状况的需求，为广大企业及员工提供安全快速的电子发薪、查薪、工资单查询，以及薪资提现、薪资预支等相关普惠金融服务。</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import _ from 'lodash';
import Title from '../../components/Title';
import store from '../../store/index'
// import {  } from '../../utils/apis';

export default {
  name: 'About',
  components: { Title },
  data: function(){
    return{
      menuType: 1,
    }
  },
  computed: {
    
  },
  mounted() {

  },
  methods: {

    
  }
}
</script>
<style lang="scss" scoped>
    .about{
      .banner{
        width: 100%;
        min-width: 1200px;
        height: 360px;
        background-image: linear-gradient(163deg, #3179F4 0%, #3AB4FF 100%);
        padding-top: 142px; 
        .banner-desc{
          height: 80px;
          text-align: center;
          .banner-desc1{
            font-size:36px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:50px;
            letter-spacing:4px;
          }
          .banner-desc2{
            font-size:20px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:28px;
            letter-spacing:4px
          }
        }
        .banner-bottom{
          height: 138px;
          min-width: 1200px;
          .banner-img{
            height: 100%;
            width: 100%
          }
        }
      }
      .introduction{
        min-width: 1200px;
        height: 100%;
        min-height: 510px;
        .concent{
          width: 740px;
          margin: 0 auto;
          .title{
            text-align: center;
            height: 170px;
            position: relative;
            padding-top: 70px;
            .title-text{
              font-size:30px;
              font-weight:400;
              color:rgba(51,51,51,1);
            }
            &::after{
                content: ' ';
                position: absolute;
                width:71px;
                height:3px;
                background:rgba(32,110,253,1);
                border-radius: 3px;
                left: 335px;
                bottom: 44px;
            }
          }
          .desc{
            text-align: center;
            .desc-text{
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
              line-height:24px;
            }
          }
        }
      }
     
    }
    
</style>
